<template>
  <div class="container">
    <ts-loading-banner :loading="waiting">
      <table class="table table-hover ui-table">
        <thead>
          <tr>
            <th>{{ $t('invoice.feeType') }}</th>
            <th>{{ $t('invoice.feeName') }}</th>
            <th class="ts-whitespace-no-wrap">{{ $t('invoice.dateFrom') }}</th>
            <th class="ts-whitespace-no-wrap">{{ $t('invoice.dateTo') }}</th>
            <th class="text-center">{{ $t('invoice.qty') }}</th>
            <th class="text-center">{{ $t('invoice.amount') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(invoice, indexInvoice) in resources">
            <tr :key="indexInvoice">
              <td colspan="7" class="ts-text-blue-600 ts-font-semibold"> {{ indexInvoice }} </td>
            </tr>
            <tr v-for="(item, index) in invoice" :key="index">
              <td class="ts-whitespace-no-wrap ts-pl-3">{{ item.fee_type_name }}</td>
              <td class="ts-whitespace-no-wrap">{{ item.fee_name }}</td>
              <td class="ts-whitespace-no-wrap">
                {{ item.fee_start_date ? item.fee_start_date : null }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ item.fee_end_date ? item.fee_end_date : null }}
              </td>
              <td class="text-center">
                {{ item.quantity ? item.quantity : null }}
              </td>
              <td class="text-center">
                {{ item.fee_amount ? roundNum(item.fee_amount) : null }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'latestInvoice',
  props: ['isActive', 'studentId', 'acpId'],
  data() {
    return {
      waiting: false,
      resources: []
    }
  },
  computed: {
    roundNum: vm => num => {
      return _.round(num, 2)
    }
  },
  methods: {
    ...mapActions('invoice', ['getLatestInvoice']),
    fetchData () {
      this.waiting = true
      this.resources = []
      this.getLatestInvoice(this.studentId)
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    studentId: function (id) {
      if (this.isActive == 3) {
        this.fetchData()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  max-height: 35vh;
  height: 30vh;
  overflow: scroll;
}
.table > thead > tr > th {
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  font-size: 12px !important;
}
</style>
